var map = {
	"./Timer_Close.svg": 6728,
	"./alarm.svg": 1759,
	"./badge-basic.svg": 7167,
	"./badge-community.svg": 9194,
	"./badge-membership.svg": 2565,
	"./badge-participation.svg": 1766,
	"./badge-role.svg": 9555,
	"./bell-notification.svg": 1310,
	"./bell-ring.svg": 7886,
	"./calendar-add.svg": 3606,
	"./calendar-check.svg": 5186,
	"./calendar-days.svg": 7790,
	"./calendar-duration.svg": 2037,
	"./calendar-event.svg": 5042,
	"./calendar.svg": 7810,
	"./checklist.svg": 3706,
	"./chevron-left.svg": 4521,
	"./clock-check.svg": 3357,
	"./clock.svg": 4235,
	"./cloud-off.svg": 4694,
	"./color.svg": 5371,
	"./copy.svg": 1732,
	"./cross.svg": 3973,
	"./dark.svg": 7222,
	"./dashboard.svg": 316,
	"./delete-solid.svg": 8056,
	"./discord.svg": 8100,
	"./download.svg": 2460,
	"./edit-pencil.svg": 649,
	"./edit-solid.svg": 8405,
	"./facebook.svg": 507,
	"./file-solid.svg": 7633,
	"./file-upload.svg": 9083,
	"./globe.svg": 9645,
	"./help.svg": 6329,
	"./image.svg": 8686,
	"./infinity.svg": 6550,
	"./info.svg": 120,
	"./layer.svg": 2181,
	"./light.svg": 8974,
	"./link-break.svg": 4865,
	"./link.svg": 5701,
	"./linkedin.svg": 6751,
	"./location.svg": 1518,
	"./log-out.svg": 4303,
	"./logo-comect-blue.svg": 2746,
	"./magnifying-glass.svg": 112,
	"./mail.svg": 8926,
	"./map.svg": 6923,
	"./member-count.svg": 4073,
	"./more-vertical.svg": 1082,
	"./note-edit.svg": 510,
	"./notebook.svg": 4484,
	"./paper-plane.svg": 4271,
	"./path.svg": 9565,
	"./plus.svg": 5080,
	"./qr-code.svg": 9109,
	"./searchIcon.svg": 76,
	"./select-multiple.svg": 7546,
	"./send-solid.svg": 2821,
	"./settings.svg": 6701,
	"./show.svg": 5806,
	"./smiley.svg": 2076,
	"./star.svg": 4240,
	"./text-align-left.svg": 8350,
	"./trash-empty.svg": 4803,
	"./trash.svg": 9167,
	"./triangle-exclamation.svg": 6875,
	"./twitter.svg": 6788,
	"./unfold-more.svg": 2402,
	"./user-add.svg": 8203,
	"./user-card-id.svg": 17,
	"./user-group.svg": 3826,
	"./user-square.svg": 3573,
	"./wavy-check.svg": 5187,
	"./website.svg": 2100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2125;